import React from "react";

function PopupRemarks({ name, object }) {
  const remarks = {
    Admin: object.adminRemarks,
    HR: object.hrRemarks,
    Accounting: object.accountingRemarks,
    Recruiter: object.recruiterRemarks,
    Coordinator: object.coordinatorRemarks,
  };

  const remark = remarks[name];
  return (
    <div
      className="position-absolute d-flex flex-column"
      style={{
        top: "50%",
        left: "120%",
        transform: "translateY(-50%)",
        zIndex: 10,
      }}
    >
      <div
        style={{
          position: "relative",
          backgroundColor: "#333",
          color: "#fff",
          padding: "8px 12px",
          borderRadius: "6px",
          fontSize: "11px",
          minWidth: "150px",
          maxWidth: "300px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          wordWrap: "break-word",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "-6px",
            transform: "translateY(-50%)",
            width: 0,
            height: 0,
            borderTop: "6px solid transparent",
            borderBottom: "6px solid transparent",
            borderRight: "6px solid #333",
          }}
        />
        {remark}
      </div>
    </div>
  );
}

export default PopupRemarks;
